import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "../Reveal";
import { useT } from "../../i18n/I18nProvider";

/** Shared journal CTA card (used on the list page and article pages). */
export const JournalCta = ({ testId = "journal-cta" }) => {
  const t = useT();

  return (
    <section className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 py-12 md:py-16">
      <Reveal className="card-flat p-8 md:p-14 grid lg:grid-cols-12 gap-6 md:gap-8 items-center">
        <div className="lg:col-span-8">
          <div className="overline mb-3 md:mb-4">{t("journal.cta.overline")}</div>
          <h3 className="font-display text-3xl sm:text-4xl md:text-5xl tracking-tightest">
            {t("journal.cta.title1")}
            <br />
            <span className="font-editorial text-ink-700">
              {t("journal.cta.titleEditorial")}
            </span>
            {t("journal.cta.titleEnd")}
          </h3>
        </div>
        <div className="lg:col-span-4 lg:justify-self-end">
          <Link to="/contatti" className="btn-pill" data-testid={testId}>
            {t("journal.cta.button")}
            <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={1.6} />
          </Link>
        </div>
      </Reveal>
    </section>
  );
};
